/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageDtoLogLogDto } from '../../models/page-dto-log-log-dto';

export interface GetLogs$Params {
  page: number;
  pageSize: number;
  createdDateFrom: string;
  createdDateTo: string;
  user?: string;
  towerId?: number;
  towerGroupId?: number;
  bookingId?: number;
  subscriptionId?: number;
  type?: Array<'CREATE_BOOKING' | 'TERMINATE_BOOKING' | 'CLONE_BOOKING' | 'UPDATE_BOOKING' | 'CREATE_SHARE' | 'UPDATE_SHARE' | 'DELETE_SHARE' | 'OPEN_BOX' | 'CLOSE_BOX' | 'TOWER_INIT_REQUEST' | 'TOWER_HEARTBEAT_CHANGE' | 'TOWER_HEARTBEAT_REQUEST' | 'TOWER_NO_HEARTBEAT' | 'CREATE_INVOICE' | 'DOWNLOAD_INVOICE' | 'CREATE_NEWS' | 'UPDATE_NEWS' | 'DELETE_NEWS' | 'CREATE_VOUCHER' | 'UPDATE_VOUCHER' | 'DELETE_VOUCHER' | 'SEND_NOTIFICATION' | 'BASE_NOTIFICATION' | 'EMAIL_NOTIFICATION' | 'PUSH_NOTIFICATION' | 'CREATE_ORGANIZATION' | 'UPDATE_ORGANIZATION' | 'DELETE_ORGANIZATION' | 'CREATE_ORGANIZATION_CONTACT' | 'UPDATE_ORGANIZATION_CONTACT' | 'DELETE_ORGANIZATION_CONTACT' | 'UPDATE_ORGANIZATION_PERMISSION' | 'CREATE_ORGANIZATION_PERMISSION_GROUP' | 'UPDATE_ORGANIZATION_PERMISSION_GROUP' | 'DELETE_ORGANIZATION_PERMISSION_GROUP' | 'CREATE_TOWER' | 'UPDATE_TOWER' | 'DELETE_TOWER' | 'BLOCK_TOWER' | 'UNBLOCK_TOWER' | 'RESET_TOWER' | 'CREATE_TOWER_GROUP' | 'UPDATE_TOWER_GROUP' | 'DELETE_TOWER_GROUP' | 'CREATE_PAYMENT_CONFIGURATION' | 'UPDATE_PAYMENT_CONFIGURATION' | 'DELETE_PAYMENT_CONFIGURATION' | 'CREATE_TOWER_GROUP_DETAIL' | 'UPDATE_TOWER_GROUP_DETAIL' | 'DELETE_TOWER_GROUP_DETAIL' | 'CREATE_USER' | 'UPDATE_USER' | 'DELETE_USER' | 'UPDATE_USER_TOPIC_SUBSCRIBE' | 'UPDATE_USER_ACCOUNT' | 'UPDATE_USER_NOTIFICATION_OPTION' | 'DELETE_USER_PROVIDER' | 'DELETE_USER_TERMS_AGREEMENT' | 'DELETE_USER_PRIVACY_AGREEMENT' | 'CREATE_ADMIN_USER' | 'UPDATE_ADMIN_USER' | 'DELETE_ADMIN_USER' | 'UPDATE_ADMIN_USER_PERMISSION' | 'UPDATE_ADMIN_USER_PERMISSION_GROUP' | 'CREATE_PARTNER_USER' | 'UPDATE_PARTNER_USER' | 'DELETE_PARTNER_USER' | 'REFUND_PAYMENT' | 'REPAY_PAYMENT' | 'CREATE_HELP_PAGE' | 'UPDATE_HELP_PAGE' | 'DELETE_HELP_PAGE' | 'CREATE_IMAGE' | 'UPDATE_IMAGE' | 'DELETE_IMAGE' | 'UPDATE_TOWER_WISH' | 'DELETE_TOWER_WISH' | 'CREATE_SUBSCRIPTION' | 'UPDATE_SUBSCRIPTION' | 'CANCEL_SUBSCRIPTION' | 'CREATE_PINPAD' | 'UPDATE_PINPAD' | 'DELETE_PINPAD' | 'RESET_PINPAD' | 'BLOCK_PINPAD'>;
  searchString?: string;
}

export function getLogs(http: HttpClient, rootUrl: string, params: GetLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoLogLogDto>> {
  const rb = new RequestBuilder(rootUrl, getLogs.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('createdDateFrom', params.createdDateFrom, {});
    rb.query('createdDateTo', params.createdDateTo, {});
    rb.query('user', params.user, {});
    rb.query('towerId', params.towerId, {});
    rb.query('towerGroupId', params.towerGroupId, {});
    rb.query('bookingId', params.bookingId, {});
    rb.query('subscriptionId', params.subscriptionId, {});
    rb.query('type', params.type, {});
    rb.query('searchString', params.searchString, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDtoLogLogDto>;
    })
  );
}

getLogs.PATH = '/api/admin/logs';
